import { useReactiveVar } from "@apollo/client";
import { localEditorShowPlaceholderLibrary } from "../../State";

export function useEditorShowPlaceholderLibrary() {
    return useReactiveVar(localEditorShowPlaceholderLibrary);
}
